export interface Category {
  id: string;
  name: string;
  slug: string;
  description: string;
  image: string;
  icon: string;
  articleCount: number;
}

export const categories: Category[] = [
  {
    id: 'cat-1',
    name: '约会攻略',
    slug: 'date-guide',
    description: '从初次约会到纪念日惊喜，为你提供最全的城市约会灵感与浪漫创意',
    image: 'https://readdy.ai/api/search-image?query=Romantic%20candlelit%20dinner%20for%20couple%20in%20elegant%20restaurant%20with%20city%20skyline%20view%2C%20warm%20ambient%20lighting%2C%20rose%20petals%20on%20table%2C%20wine%20glasses%2C%20intimate%20atmosphere%2C%20soft%20bokeh%20background%2C%20luxury%20dining%20experience%2C%20warm%20cream%20and%20rose%20gold%20tones&width=800&height=500&seq=category-date-guide&orientation=landscape',
    icon: 'ri-heart-line',
    articleCount: 286,
  },
  {
    id: 'cat-2',
    name: '蜜月旅行',
    slug: 'honeymoon',
    description: '精选全球蜜月胜地，从海岛到古城，打造一生难忘的新婚之旅',
    image: 'https://readdy.ai/api/search-image?query=Luxury%20overwater%20bungalow%20resort%20with%20crystal%20clear%20turquoise%20ocean%2C%20couple%20walking%20on%20white%20sand%20beach%20at%20sunset%2C%20tropical%20paradise%2C%20palm%20trees%2C%20romantic%20honeymoon%20destination%2C%20warm%20golden%20light%2C%20dreamy%20atmosphere&width=800&height=500&seq=category-honeymoon&orientation=landscape',
    icon: 'ri-plane-line',
    articleCount: 158,
  },
  {
    id: 'cat-3',
    name: '浪漫套餐',
    slug: 'romantic-packages',
    description: '精选情侣专属酒店套餐、SPA体验和烛光晚餐，一站式浪漫预订',
    image: 'https://readdy.ai/api/search-image?query=Luxury%20couple%20spa%20treatment%20room%20with%20rose%20petals%20floating%20in%20water%2C%20candles%20everywhere%2C%20soft%20towel%20arrangements%2C%20premium%20essential%20oils%2C%20relaxing%20warm%20atmosphere%2C%20five%20star%20resort%20interior%2C%20cream%20and%20gold%20decor&width=800&height=500&seq=category-packages&orientation=landscape',
    icon: 'ri-gift-line',
    articleCount: 94,
  },
  {
    id: 'cat-4',
    name: '打卡景点',
    slug: 'photo-spots',
    description: '最出片的浪漫打卡地标，用镜头记录爱情最美的样子',
    image: 'https://readdy.ai/api/search-image?query=Beautiful%20instagram%20worthy%20romantic%20travel%20spot%20with%20flower%20tunnel%20and%20fairy%20lights%2C%20couple%20posing%20naturally%2C%20golden%20hour%20sunlight%2C%20dreamy%20garden%20setting%2C%20vibrant%20blooming%20flowers%2C%20magical%20atmosphere%2C%20warm%20pastel%20tones&width=800&height=500&seq=category-photo-spots&orientation=landscape',
    icon: 'ri-camera-line',
    articleCount: 312,
  },
  {
    id: 'cat-5',
    name: '度假推荐',
    slug: 'resort-recommendations',
    description: '精选情侣度假村和特色民宿，享受属于两个人的慢时光',
    image: 'https://readdy.ai/api/search-image?query=Luxury%20romantic%20mountain%20resort%20with%20private%20hot%20spring%20pool%20overlooking%20valley%2C%20couple%20enjoying%20sunset%20view%2C%20elegant%20room%20with%20king%20bed%20and%20rose%20petals%2C%20wooden%20interior%20design%2C%20cozy%20fireplace%2C%20warm%20ambient%20lighting&width=800&height=500&seq=category-resort&orientation=landscape',
    icon: 'ri-hotel-line',
    articleCount: 203,
  },
  {
    id: 'cat-6',
    name: '美食探店',
    slug: 'food-discovery',
    description: '寻觅城市中最适合约会的浪漫餐厅与甜品店',
    image: 'https://readdy.ai/api/search-image?query=Elegant%20romantic%20restaurant%20interior%20with%20dim%20lighting%20and%20candles%2C%20gourmet%20dishes%20artfully%20plated%2C%20couple%20sharing%20dessert%2C%20city%20night%20view%20through%20floor%20to%20ceiling%20windows%2C%20warm%20intimate%20vibe%2C%20rose%20gold%20decor%20details&width=800&height=500&seq=category-food&orientation=landscape',
    icon: 'ri-restaurant-line',
    articleCount: 227,
  },
];